import { render, staticRenderFns } from "./fullScreenAtt.vue?vue&type=template&id=779a9bbc&scoped=true&"
import script from "./fullScreenAtt.vue?vue&type=script&lang=js&"
export * from "./fullScreenAtt.vue?vue&type=script&lang=js&"
import style0 from "./fullScreenAtt.vue?vue&type=style&index=0&id=779a9bbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779a9bbc",
  null
  
)

export default component.exports